import { Stack, styled } from "@mui/material";

export const AccessControlWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        overflow: "hidden",
        "& .role-form-box": {
            padding: "var(--basic-padding)",
            backgroundColor: "var(--light-color)",
            borderRadius: "16px",
            [theme.breakpoints.up(590)]: {
                width: "25%",
                marginLeft: "auto"
            },
            [theme.breakpoints.between("tablet", "laptop")]: {
                width: "auto",
                marginLeft: 0
            }
        },
        "& .access-control-box": {
            padding: "var(--basic-padding)",
            backgroundColor: "var(--light-color)",
            borderRadius: "16px",
            "& .module-title": {
                backgroundColor: "var(--primary-color)",
                padding: "var(--basic-padding)",
                borderRadius: "8px",
            }
        }
    }
})